import { render, staticRenderFns } from "./purposeListng.vue?vue&type=template&id=5312e31e&scoped=true&"
import script from "./purposeListng.vue?vue&type=script&lang=js&"
export * from "./purposeListng.vue?vue&type=script&lang=js&"
import style0 from "./purposeListng.vue?vue&type=style&index=0&id=5312e31e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5312e31e",
  null
  
)

export default component.exports